import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useTrendingArticles(limit = 5) {
  const [trendingSlugs, setTrendingSlugs] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrending = async () => {
      try {
        const { data, error } = await supabase.functions.invoke("trending-articles");
        if (error) {
          console.error("Failed to fetch trending:", error.message);
          setLoading(false);
          return;
        }
        setTrendingSlugs((data?.slugs || []).slice(0, limit));
      } catch (e) {
        console.error("Trending fetch error:", e);
      }
      setLoading(false);
    };

    fetchTrending();
  }, [limit]);

  return { trendingSlugs, loading };
}
